import './jquery.mask'

const lightbox = GLightbox({
    'selector': '.glight-video',
    'href': 'https://www.youtube.com/watch?v=bsPAj7vESz0',
    'type': 'video',
    'source' : 'youtube',
    'width': 500,
});
 

// ----------/ Forms //------------ //
const maskCNPJ = '00.000.000/0000-00'
const maskPHONE = '(00) 00000-0000'
let cnpjLenght = maskCNPJ.length
let phoneLenght = maskPHONE.length
$('#itg-cnpj').mask(maskCNPJ);
$('#itg-phone').mask(maskPHONE);

$("#itg-phone").keydown(function () {
    try {
        $("#itg-phone").unmask();
    } catch (e) { }

    var tamanho = $("#itg-phone").val().length;

    if (tamanho < 10) {
        $("#itg-phone").mask("(99) 9999-9999");
    } else {
        $("#itg-phone").mask("(99) 99999-9999");
    }

    // ajustando foco
    var elem = this;
    setTimeout(function () {
        // mudo a posição do seletor
        elem.selectionStart = elem.selectionEnd = 10000;
    }, 0);
    // reaplico o valor para mudar o foco
    var currentValue = $(this).val();
    $(this).val('');
    $(this).val(currentValue);
});

// Forms

function errorModal(title, text) {
    Swal.fire({
        title: title,
        text: text,
        imageUrl: site_url + 'site/img/iconError.png',
        imageWidth: 76,
        imageHeight: 76
    });
}

$('#integrador-forms').on("submit", function (e) {
    $('.modalLoader').show();
    var form = $(this);
    e.preventDefault();
    let error = false
    const inputs = form.serializeArray()

    inputs.forEach((input, indice) => {
        const name = input.name
        const value = input.value

        if (!error) {
            switch (name) {
                case 'name': {
                    const regex = /\d+/;
                    if (value == '') {
                        $('.modalLoader').hide();
                        errorModal('Nome', 'Digite um nome válido !')
                        error = true
                    } else if (regex.test(value)) {
                        $('.modalLoader').hide();
                        errorModal('Nome', 'Não coloque números em seu nome !')
                        error = true
                    }
                    break
                }

                case 'role': {

                    if (value == '') {
                        $('.modalLoader').hide();
                        errorModal('O que você é ?', 'Selecione qual sua função no campo "O que você é ?')
                        error = true
                    }

                    break
                }

                case 'role_other': {
                    if (inputs[2].value == 'Outros' && value == '') {
                        $('.modalLoader').hide();
                        errorModal('O que você é ?', 'Digite qual sua função no campo "O que você é ?')
                        error = true
                    }

                    break
                }

                // case 'document': {
                //     if (value == '') {
                //         $('.modalLoader').hide();
                //         errorModal('CNPJ', 'Informe seu CNPJ !')
                //         error = true

                //     } else if (value.length < cnpjLenght) {
                //         $('.modalLoader').hide();
                //         errorModal('CNPJ', 'Número de CNPJ inválido !')
                //         error = true
                //     }
                //     break
                // }

                case 'email': {
                    if (value == '') {
                        $('.modalLoader').hide();
                        errorModal('E-mail', 'Informe seu E-mail !')
                        error = true

                    } else if (value.length < cnpjLenght) {
                        $('.modalLoader').hide();
                        errorModal('E-mail', 'E-mail inválido !')
                        error = true
                    }
                    break
                }

                case 'phone': {
                    if (value == '') {
                        $('.modalLoader').hide();
                        errorModal('Telefone', 'Informe seu telefone !')
                        error = true
                    } else if (value.length < 14) {
                        $('.modalLoader').hide();
                        errorModal('Telefone', 'Número de telefone inválido !')
                        error = true
                    }
                    break
                }

                case 'interests': {
                    if (value == '') {
                        $('.modalLoader').hide();
                        errorModal('Interesses', 'Informe qual o seu interesse conosco !')
                        error = true
                    }
                    break
                }
            }
        }
    })

    if (!error) {
        $('.modalLoader').show();
        grecaptcha.ready(function () {
            grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
                action: 'submit'
            }).then(function (token) {

                var match = document.cookie.match(new RegExp('(^| )' + '__trf.src' + '=([^;]+)'));
                var traffic_source = '';
                if (match) {
                    traffic_source = match[2];
                }

                var data;
                var contentType = "application/x-www-form-urlencoded";
                var processData = true;

                if ($(form).attr('enctype') == 'multipart/form-data') {
                    data = new FormData($('.form-file').get(0));
                    data.append('gRecaptchaResponse', token);
                    data.append('traffic_source', traffic_source);
                    contentType = false;
                    processData = false;
                } else {
                    data = $(form).serialize() + '&gRecaptchaResponse=' + token + '&traffic_source=' + traffic_source;
                }

                $.ajax({
                    data: data,
                    type: $(form).attr('method'),
                    url: $(form).attr('action'),
                    dataType: 'json',
                    contentType: contentType,
                    processData: processData,
                    beforeSend: function () {
                        $(form).find('button').addClass('load');
                        $(form).find('input,button').prop("disabled", true);
                    },
                    success: function (data) {
                        $('.modalLoader').hide();
                        if (data.status) {
                            window.location = $(form).attr('redirect');
                        } else {
                            Swal.fire({
                                title: jsi18n.form_invalid_title,
                                html: data.msgWarning,
                                imageUrl: site_url + 'site/img/iconError.png',
                                imageWidth: 76,
                                imageHeight: 76
                            });
                            $(form).find('input,button').prop("disabled", false);
                            $(form).find('button').removeClass('load');
                        }
                    },
                    error: function (data) {
                        $('.modalLoader').hide();
                        Swal.fire({
                            title: jsi18n.ajax_error_title,
                            text: jsi18n.ajax_error_message,
                            imageUrl: site_url + 'site/img/iconError.png',
                            imageWidth: 76,
                            imageHeight: 76
                        });
                        $(form).find('input,button').prop("disabled", false);
                        $(form).find('button').removeClass('load');
                    }
                });

            });
        });
    }

});


